import {GetDoc, CreateAccessor} from "mobx-graphlink";
import {UserHidden} from "./userHiddens/@UserHidden";
import {MeID} from "./users.js";

export const GetUserHidden = CreateAccessor((userID: string|n): UserHidden|n=>{
	return GetDoc({}, a=>a.userHiddens.get(userID!));
});

export const GetMyGridEntityNames = CreateAccessor(()=>{
	const meID = MeID();
	if (meID == null) return [];
	const userHidden = GetUserHidden(meID);
	return userHidden?.gridEntityNames ?? [];
});